// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"home_wrapper__36g6d","container":"home_container__1PRq5","body":"home_body__crFsG"};